module.exports = __webpack_public_path__ + "img/partner_12.338d4465.png";